import { urlApi } from "../utils/strings";

export interface ContactoItem {
  id: number;
  correo: string;
  categoria: string;
}

export const getContactos = async (): Promise<ContactoItem[]> => {
  const url = urlApi(`/contacto/consultarContacto.php`);
  const response = await fetch(url);
  const data = await response.json();

  if (data?.status === "success" && Array.isArray(data.data)) {
    return data.data.map((item: any) => ({
      id: Number(item.id),
      correo: item.correo || "",
      categoria: item.categoria || "",
    }));
  }

  return [];
};

export const updateCorreo = async ({ id, correo }: { id: number; correo: string }) => {
  const url = urlApi(`/contacto/actualizarCorreo.php`);

  const response = await fetch(url, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ id, correo }),
  });

  const resp = await response.json();

  if (response.ok) {
    return resp;
  } else {
    throw new Error("Error al actualizar correo");
  }
};
